<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card">
      <table class="setting-table">
        <tr @click="chengepassRoutHandler">
          <td>
            <!-- <input type="checkbox" id="switchSms" /><label for="switchSms"></label> -->
          </td>
          <td>تغییر گذرواژه</td>
          <td>
            <img src="@/assets/icons/key.svg" />
          </td>
        </tr>
        <tr>
          <td>
            <input type="checkbox" id="switchFingerPrint" /><label
              for="switchFingerPrint"
            ></label>
          </td>
          <td>ورود با اثر انگشت</td>
          <td>
            <img src="@/assets/icons/fingerprint.svg" style="filter: none" />
          </td>
        </tr>
        <tr @click="ctiveSessionRoutHandler">
          <td>
            <!-- <input type="checkbox" id="switchSms" /><label for="switchSms"></label> -->
          </td>
          <td>دستگاه‌های شما</td>
          <td>
            <img src="@/assets/icons/sms.svg" />
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  components: {
    InsHeader,
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {};
  },
  methods: {
    chengepassRoutHandler() {
      this.$router.push({ name: "ChengePassword" });
    },
    ctiveSessionRoutHandler() {
      this.$router.push({ name: "DeviceSession" });
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
label {
  cursor: pointer;
  text-indent: -9999px;
  width: 40px;
  height: 20px;
  background: grey;
  display: block;
  border-radius: 100px;
  position: relative;
  margin-top: -15px;
}
</style>
